import Weather from 'components/Weather/Weather';

const HomePage = () => {
  return (
    <div>
      <Weather />
    </div>
  );
};

export default HomePage;
